import {
  UtimacoCircuitSwitchState,
  UtimacoCircuitSwitchActionTypes,
  GET_UTIMACO_CIRCUIT_SWITCH_LIST,
  GET_UTIMACO_CIRCUIT_SWITCH_LIST_FULFILLED,
  GET_UTIMACO_CIRCUIT_SWITCH_PENDING,
  GET_UTIMACO_CIRCUIT_SWITCH_FULFILLED,
  SELECT_UTIMACO_CIRCUIT_SWITCH,
  CREATE_UTIMACO_CIRCUIT_SWITCH_PENDING,
  CREATE_UTIMACO_CIRCUIT_SWITCH_FULFILLED,
  DELETE_UTIMACO_CIRCUIT_SWITCH_FULFILLED,
  SET_UTIMACO_CIRCUIT_SWITCH_LOADING,
} from './utimacoCircuitSwitch.types';

export const initialState: UtimacoCircuitSwitchState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function utimacoCircuitSwitchReducer(
  state = initialState,
  action: UtimacoCircuitSwitchActionTypes,
): UtimacoCircuitSwitchState {
  switch (action.type) {
    case GET_UTIMACO_CIRCUIT_SWITCH_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_UTIMACO_CIRCUIT_SWITCH_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };

    case GET_UTIMACO_CIRCUIT_SWITCH_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_UTIMACO_CIRCUIT_SWITCH_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_UTIMACO_CIRCUIT_SWITCH:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_UTIMACO_CIRCUIT_SWITCH_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_UTIMACO_CIRCUIT_SWITCH_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_UTIMACO_CIRCUIT_SWITCH_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_UTIMACO_CIRCUIT_SWITCH_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
